import React from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";

//styles
import { useStyles } from "./styles";

interface ILogRowProps {
  data: any;
  action: string;
}

const LogRow: React.FC<ILogRowProps> = ({ data, action }) => {
  const { t } = useTranslation();
  const styles = useStyles();

  switch (action) {
    case "rsImpactOnCpa":
      return (
        <Typography className={styles.text} variant="body2" component="p">
          {t("common.logs.switchUpdated")}{" "}
          "<b>{t(`common.logs.flags.rsImpactOnCpa`)}</b>"{" "}
          {t("common.logs.wasUpdatedBy")}{" "}
          <b>{data.changedByUserName}</b>{" "}
          <b>(ID: {data.changedById})</b>.{" "}
          {t("common.logs.valueChanged")}{" "}
          "{data.changes.from ? t("common.logs.enabled") : t("common.logs.disabled")}"{" "}
          {t("common.logs.to")}{" "}
          "<b>{data.changes.to ? t("common.logs.enabled") : t("common.logs.disabled")}</b>".
        </Typography>
      );
    default:
      return null;
  }
};

export default LogRow;
